import getClientApiRequestTransformer from '@/api/transformers/auth.request.transformer';
import getSocketIdRequestTransformer from '@/api/transformers/socketId.request.transformer';

export default {
  editPlace(editedFields: any) {
    return window.axios.patch(
      '/place/edit',
      editedFields,
      {
        transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
      },
    );
  },
  editPlaceWidgetSettings(widgetSettings: any) {
    return window.axios.patch(
      '/place/settings/widget/update',
      {
        widget: widgetSettings,
      },
      {
        transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
      },
    );
  },
  editPlaceDiscountSettings(discountSettings: any) {
    return window.axios.patch(
      '/place/settings/discount/update',
      {
        discountSettings,
      },
      {
        transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
      },
    );
  },
};
